import React, { TextareaHTMLAttributes } from 'react';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  inputClassName?: string;
  tooltip?: string;
}

const MLTextArea: React.FC<TextAreaProps> = ({ error, inputClassName, label, placeholder, tooltip, ...props }) => {
  return (
    <>
      <label htmlFor="basiInput" className={`form-label ${error ? 'text-danger' : ''}  mb-1`} title={tooltip}>
        {label}
        {props.required && <span className="text-danger m-1">*</span>}
      </label>
      <textarea className={inputClassName} id="basicInput" placeholder={placeholder} {...props} />
      {error && <div className="text-danger w-100 d-block mt-1">{error}</div>}
    </>
  );
};

export default MLTextArea;
